'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Small = require('UIComponents/elements/Small');

var _Small2 = _interopRequireDefault(_Small);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function PlainLabel(_ref) {
  var children = _ref.children;

  return _react2.default.createElement(
    'span',
    { className: 'text-center m-y-2' },
    _react2.default.createElement(
      'p',
      { className: 'm-bottom-0' },
      _react2.default.createElement(
        _Small2.default,
        { use: 'help' },
        children
      )
    )
  );
}

PlainLabel.propTypes = {
  children: _react.PropTypes.node.isRequired
};

exports.default = PlainLabel;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-messages/static-1.640/js/label/PlainLabel.js
// module id = 1146
// module chunks = 2 3